import { ResolvedTheme } from '../context/ThemeContext';

export interface ThemeTokens {
    text: string;
    textHover: string;
    subtleText: string;
    gridLine: string;
    axisLine: string;
    tooltipBg: string;
    tooltipBorder: string;
    legendActive: string;
    legendInactive: string;
    legendHidden: string;
    pieLabelOutline: string;
    navButtonFill: string;
    navButtonStroke: string;
    seriesBorder: string;
}

// ──────────────────────────────────────────────────────────────────────
// Theme tokens — one object per theme
// ──────────────────────────────────────────────────────────────────────

export const chartThemeTokens: Record<ResolvedTheme, ThemeTokens> = {
    light: {
        text: '#333',
        textHover: '#000',
        subtleText: '#666',
        gridLine: '#e6e6e6',
        axisLine: '#ccd6eb',
        tooltipBg: '#fff',
        tooltipBorder: '#999',
        legendActive: '#003399',
        legendInactive: '#cccccc',
        legendHidden: '#ccc',
        pieLabelOutline: '1px contrast',
        navButtonFill: '#fff',
        navButtonStroke: '#ccd6eb',
        seriesBorder: '#fff',
    },
    dark: {
        text: '#e0e0e0',
        textHover: '#fff',
        subtleText: '#adb5bd',
        gridLine: '#444460',
        axisLine: '#444460',
        tooltipBg: '#2a2a3c',
        tooltipBorder: '#555',
        legendActive: '#6ea8fe',
        legendInactive: '#555',
        legendHidden: '#555',
        pieLabelOutline: 'none',
        navButtonFill: '#2a2a3c',
        navButtonStroke: '#444460',
        seriesBorder: '#2a2a3c',
    },
    midnight: {
        text: '#e0e0e0',
        textHover: '#fff',
        subtleText: '#8391a2',
        gridLine: '#1a4a6e',
        axisLine: '#1a4a6e',
        tooltipBg: '#0a2d4e',
        tooltipBorder: '#1a4a6e',
        legendActive: '#6ea8fe',
        legendInactive: '#3f72a4',
        legendHidden: '#3f72a4',
        pieLabelOutline: 'none',
        navButtonFill: '#02203e',
        navButtonStroke: '#1a4a6e',
        seriesBorder: '#02203e',
    },
};
